/**
 * The OAuth consent screen's rules, apart from React so they can be tested.
 * The server (`pb/pb_hooks/oauth-lib.js`) decides everything; this only reads its answer.
 */

/** What `GET /api/oauth/consent/:id` returns. */
export type ConsentView = {
  client_name: string;
  client_kind: "dcr" | "cimd" | string;
  /** The host of Claude's metadata document, or `self-registered` for a DCR client. */
  client_host: string;
  /** Where the answer goes, with the port for a loopback redirect. */
  redirect_host: string;
  is_loopback: boolean;
  scope: string;
  email: string;
  expires_at: string;
};

const CONSENT_PATH = /^\/oauth\/consent\/([a-z0-9]{32})\/?$/;

/** The sign-in id in a router pathname such as `/oauth/consent/<id>`, or null. */
export function consentIdFromPath(pathname: string): string | null {
  return CONSENT_PATH.exec(pathname)?.[1] ?? null;
}

/** The line under the app's name: who vouches for it. */
export function clientHostLabel(view: Pick<ConsentView, "client_host">): string {
  return view.client_host === "self-registered" || !view.client_host ? "แอปที่ลงทะเบียนเอง" : view.client_host;
}

export function clientName(view: Pick<ConsentView, "client_name">): string {
  return view.client_name.trim() || "แอปที่ไม่ได้ระบุชื่อ";
}

/**
 * The server only ever sends Claude's callbacks or a loopback address back; this checks
 * it again before the browser leaves Kobo, so a bug there cannot become an open redirect.
 */
export function isSafeRedirect(value: string): boolean {
  let url: URL;
  try {
    url = new URL(value);
  } catch {
    return false;
  }
  if (url.username || url.password || url.hash) return false;
  if (url.protocol === "https:") {
    return (url.hostname === "claude.ai" || url.hostname === "claude.com") && url.port === "" && url.pathname === "/api/mcp/auth_callback";
  }
  return url.protocol === "http:" && ["localhost", "127.0.0.1", "[::1]"].includes(url.hostname);
}
